import { Component, ChangeDetectionStrategy } from "@angular/core";

@Component({
  selector: "bit-menu-divider",
  templateUrl: "./menu-divider.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuDividerComponent {}
